export default __webpack_public_path__ + "static/media/profile.eee283c1.jpg";